export const OPTHINES = {
  voteName: '2019poject/2019likesyhao',
  themeColor: {
    activeBgColor: '#3352e1',
    inactiveBgColor: '#ffffff',
  },
  tabs: [
    {
      tabName: '上游号评选',
      tabPath: '/2019VoteForShangYouHao/ListPage',
    },
    {
      tabName: '评选规则',
      tabPath: '/2019VoteForShangYouHao/SelectRules',
    },

  ],
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
};
